<template>
  <money3
    v-model="price"
    v-bind="moneyConfig"
    text-right
    class="price-input"
    @blur.native="$emit('blur')"
  />
</template>

<script>
import { Money3Component } from "v-money3";

export default {
  components: {
    money3: Money3Component
  },
  props: {
    value: {
      type: [Number, String, null],
      default: null
    }
  },
  emits: ["blur", "price-change"],
  data() {
    return {
      moneyConfig: {
        decimal: ".",
        thousands: ",",
        prefix: "$",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  },
  computed: {
    price: {
      get() {
        return this.value / 100;
      },
      set(val) {
        const cents = parseFloat((val * 100).toFixed(0));
        if (cents !== this.value) {
          this.$emit("price-change", cents);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
